import React, { useEffect, useState } from "react";
import RoundedIconButton from "../Buttons/RoundedIconButton/RoundedIconButton";
import {
  ListItem,
  ListTitle,
  ListSubtitle,
  ListText,
  ArrowWrapper,
  FlexContainer,
} from "./ActionsList.styled";
import ConfigureScheduleLinkModal from "../modals/ConfigureScheduleLinkModal";
import { ChevronRight, ChevronLeft } from "@mui/icons-material";
import { useStore } from "../../../hooks";

const ActionItem = ({
  icon,
  title,
  subtitle,
  onClick,
  ConfigurationIcon,
  arrowDirection,
}) => {
  const [isConfigModalOpen, setIsConfigModalOpen] = useState(false);
  const [isConfigModalTouched, setIsConfigModalTouched] = useState(false);
  const { editAgent } = useStore();

  const handleConfigClick = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setIsConfigModalOpen(true);
  };

  const showConfigIcon =
    title?.toLowerCase().includes("repair") ||
    title?.toLowerCase().includes("schedule");

  const configureActionName = () => {
    if (title?.toLowerCase().includes("repair")) {
      return "repair_schedule";
    }
    return "appointment_schedule";
  };

  return (
    <>
      <ListItem onClick={onClick}>
        <FlexContainer>
          {arrowDirection === "left" && (
            <ArrowWrapper>
              <ChevronLeft />
            </ArrowWrapper>
          )}
          <RoundedIconButton icon={icon} width="24px" height="24px" />
          <ListText>
            <ListTitle>{title}</ListTitle>
            <ListSubtitle>{subtitle}</ListSubtitle>
          </ListText>
        </FlexContainer>
        <FlexContainer>
          {arrowDirection === "right" && (
            <ArrowWrapper>
              <ChevronRight />
            </ArrowWrapper>
          )}
          {ConfigurationIcon && showConfigIcon && (
            <div onClick={(e) => e.stopPropagation()}>
              <RoundedIconButton
                icon={"customSettings"}
                width="20px"
                height="20px"
                onClick={handleConfigClick}
              />
            </div>
          )}
        </FlexContainer>
      </ListItem>
      {isConfigModalOpen && (
        <ConfigureScheduleLinkModal
          isOpen={isConfigModalOpen}
          configureActionName={configureActionName()}
          onClose={() => {
            setIsConfigModalOpen(false);
            if (isConfigModalTouched) {
              editAgent.onChangeActionsSettingsTouched(configureActionName());
              setIsConfigModalTouched(false);
            }
          }}
          onSave={() => {
            setIsConfigModalTouched(false);
            setIsConfigModalOpen(false);
          }}
          onTouched={() => setIsConfigModalTouched(true)}
        />
      )}
    </>
  );
};

export default ActionItem;
